import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";

const FMUTextField = ({
  label,
  field,
  multiline = false,
  fullwidth = false,
  disableUnderline = false,
  inputLabelProps = {},
  form: { dirty, touched, errors },
  ...other
}) => {
  const errorText = errors[field.name];
  const hasError = dirty && touched[field.name] && errorText !== undefined;
  return (
    <TextField
      label={label}
      error={hasError}
      multiline={multiline}
      fullWidth={fullwidth}
      InputLabelProps={inputLabelProps}
      InputProps={{ disableUnderline }}
      {...field}
      {...other}
    />
  );
};

FMUTextField.propTypes = {
  // label: PropTypes.string.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  form: PropTypes.shape({
    dirty: PropTypes.bool,
    errors: PropTypes.object,
    touched: PropTypes.object,
  }).isRequired,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  margin: PropTypes.oneOf(["none", "dense", "normal"]),
};

FMUTextField.defaultProps = {
  fullWidth: true,
  margin: "normal",
};
export default FMUTextField;
